import { FC, ReactNode } from 'react';
import classNames from 'clsx';
import sanitizer from '@helpers/sanitizer';
import styles from './info-box.module.scss';

export type InfoBoxProps = {
  variant: 'info' | 'warning' | 'success' | 'danger';
  titleIcon?: ReactNode;
  title: string;
  description: string;
  children?: ReactNode;
};

export const InfoBox: FC<Partial<InfoBoxProps>> = ({ variant, titleIcon, title, description, children }) => {
  return (
    <div className={classNames(styles.box, styles[`box--${variant}`])}>
      <div className={styles.box__title}>
        {titleIcon}
        <h3 className={styles.box__title__text}>{title}</h3>
      </div>
      <div className={styles.box__description}>
        <span
          className={styles.box__description__text}
          dangerouslySetInnerHTML={{ __html: sanitizer(String(description)) }}
        />
      </div>
      {children}
    </div>
  );
};
